import { useContext, useState } from 'react';
import { createProgramInFirestore } from '../../utilityFunctions/firestoreUtilities';
import { AuthContext } from '../../AuthContext';
import { cleanText } from '../../utilityFunctions/uxUtilities';
import StateOptions from './StateOptions';
import {NteeDropdown} from "./NteeDropdown";

const CreateProgramModal = ({ 
        currentClientOrganization,
        fetchProgramsForOrganization,        
        setCurrentProgram,  
        setShowCreateProgramModal,
    }) => {

    const { authUser } = useContext(AuthContext);
    
    // State for the form values
    const [formValues, setFormValues] = useState({
        programName: '',        
        primaryState: '',
        nteeFull: '',
        additionalDetails: '',        
    });

    // Submit form to create a program
    const handleSubmit = async () => {
        const userId = authUser.uid;

        // Check if all fields are filled
        const { programName, primaryState, nteeFull, additionalDetails } = formValues;
        if (!programName || !primaryState || !nteeFull || !additionalDetails) {
            alert("Please fill in all fields before submitting.");
            return; // Prevent submission if any field is empty
        }

        const cleanedFormValues = {
            programName: cleanText(programName),
            primaryState: cleanText(primaryState),
            nteeFull: cleanText(nteeFull),
            additionalDetails: cleanText(additionalDetails)
        };

        const newProgram = await createProgramInFirestore(cleanedFormValues, userId, currentClientOrganization.id, cleanedFormValues.programName);
        const refreshedPrograms = await fetchProgramsForOrganization(currentClientOrganization.id);
        
        const updatedProgram = refreshedPrograms.find(program => program.id === newProgram.id);
        setCurrentProgram(updatedProgram);
        setShowCreateProgramModal(false);
    };
    
    // Handle form input changes 
    const handleChange = (field, value) => {
        setFormValues(prevValues => ({
            ...prevValues,
            [field]: value
        }));
    };

    return (
        <div 
            className="modal-overlay" 
            style={{ position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', backgroundColor: 'rgba(0, 0, 0, 0.5)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 9999 }}
            onClick={() => setShowCreateProgramModal(false)}
        >
            <div 
                className="modal p-4 sm:p-6 lg:p-8 overflow-auto max-h-full mx-4 sm:mx-0" 
                style={{ 
                    cursor: 'default', 
                    width: '95vw',
                    maxWidth: '600px',
                    minHeight: 'auto',
                    maxHeight: '90vh',
                    backgroundColor: 'white', 
                    borderRadius: '10px'
                }}
                onClick={(e) => e.stopPropagation()} // Prevent click event from propagating to the overlay
            >
                {/* <p className="text-3xl mt-10 font-bold text-left">{existingProgram ? 'Update Program' : 'Program Details'}</p>                  */}
                <p className="text-2xl sm:text-3xl mt-6 sm:mt-10 font-bold text-left">Create New Program</p>                 
                <p className="text-sm mt-2 text-left">We will monitor for new grants based on your program details.</p>
                
                <div className='text-left mt-6 sm:mt-10'>
                    
                    <div className="mb-4">
                        <label className="block font-bold mb-2 text-sm sm:text-base">Program Name <span className="text-red-500">*</span></label>
                        <input 
                            className="w-full p-2 sm:p-3 border rounded text-sm sm:text-base" 
                            value={formValues.programName}
                            onChange={(e) => handleChange('programName', e.target.value)}
                            required
                        />
                    </div>
                   
                    <NteeDropdown 
                        onChange={(value) => {
                            console.log("NTEE Code: ", value);
                            handleChange('nteeFull', value)
                        }} 
                        code={formValues.nteeFull}
                    >
                        <label className="block font-bold mb-1 text-sm sm:text-base">NTEE Code <span className="text-red-500">*</span></label>
                        <p className="text-xs sm:text-sm mb-2 text-left italic text-gray-500">
                            To find your NTEE code, please visit the IRS <a className="text-indigo-500" href="https://urbaninstitute.github.io/nccs-legacy/ntee/ntee.html" target="_blank" rel="noopener noreferrer">Activity Codes page</a>.
                        </p>
                    </NteeDropdown>

                    <div className="mb-4">
                        <label className="block font-bold mb-2 text-sm sm:text-base">Primary State Served <span className="text-red-500">*</span></label>
                        <select 
                            className="w-full p-2 sm:p-3 border rounded text-sm sm:text-base" 
                            value={formValues.primaryState}
                            onChange={(e) => handleChange('primaryState', e.target.value)}
                            required
                        >
                            <StateOptions />
                        </select>
                    </div>
                    <div className="mb-4">
                        <label className="block font-bold mb-2 text-sm sm:text-base">Additional Details <span className="text-red-500">*</span></label>
                        <p className="text-xs sm:text-sm mb-2 text-left italic text-gray-500">
                        Tell us more about your nonprofit program: who you serve and what services you provide. This helps us match you with the right funders and support AI grant writing.
                        </p>
                        <textarea 
                            className="w-full p-2 sm:p-3 border rounded text-sm sm:text-base" 
                            value={formValues.additionalDetails}
                            rows="3"
                            onChange={(e) => handleChange('additionalDetails', e.target.value)}
                            placeholder="e.g. 'We serve children in the state of California'"
                            required
                        />
                    </div>

                    <div className='flex flex-col sm:flex-row items-center gap-3 sm:space-x-4'>
                        <button 
                            className="mt-4 p-2 sm:p-3 bg-blue-500 text-white rounded text-sm sm:text-base w-full sm:w-auto" 
                            onClick={handleSubmit}
                        >
                            Submit
                        </button>
                        <button 
                            className="mt-2 sm:mt-4 p-2 sm:p-3 bg-gray-500 text-white rounded text-sm sm:text-base w-full sm:w-auto" 
                            onClick={() => setShowCreateProgramModal(false)}
                        >
                            Cancel
                        </button>
                    </div>
                </div>                        
            </div>
        </div>
    );
};

export default CreateProgramModal;